<template>
  <div class="charts" style="width: 100%; height: 100%"></div>
</template>
<script>
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/bar'
import defaultsdeep from 'lodash.defaultsdeep'
export default {
  name: 'BarCharts',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    xAxisData: {
      type: Array,
      default() {
        return []
      }
    },
    option: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    data() {
      this.createCharts()
    }
  },
  mounted() {
    this.createCharts()
  },
  methods: {
    createCharts() {
      if (!this.Chart) this.Chart = echarts.init(this.$el)
      this.Chart.setOption(
        defaultsdeep(
          {},
          {
            grid: {
              left: '0%',
              right: '0%',
              bottom: '0%',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                data: this.xAxisData,
                axisLine: {
                  lineStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: '#666' // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: '#999' // 100% 处的颜色
                        }
                      ],
                      globalCoord: false
                    }
                  }
                },
                axisTick: {
                  alignWithLabel: true
                }
              }
            ],
            yAxis: [
              {
                type: 'value',
                axisLine: {
                  show: false
                },
                axisTick: {
                  show: false
                },
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              }
            ],
            series: [
              {
                type: 'bar',
                data: this.data,
                barWidth: '80%', // 柱子宽度
                barGap: '10%',
                label: {
                  normal: {
                    show: true,
                    formatter: '{c}份',
                    position: 'top'
                  }
                }
              }
            ]
          },
          this.option
        )
      )
    }
  }
}
</script>
